import React from "react";
//import { Link } from "react-router-dom";
import Logo from "../Logo";
import Search from "../Search";

export default function Topbar(props: any) {
  //const hostname = window.location.hostname;
  //console.log("pages", props.pages);
  const pathname = window.location.pathname;
  const isDocumenation: boolean =
    pathname !== "/" &&
    pathname !== "/overview" &&
    pathname !== "/solutions" &&
    pathname !== "/community";
  const isOverview: boolean = pathname === "/" || pathname === "/overview";
  //const isTemplates: boolean = pathname === "/solutions";
  const isCommunity: boolean = pathname === "/community";
  return (
    <header
      className={`topbar ${props.mobileMainMenuOpen ? "mob-menu-is-open" : ""}`}
    >
      <Logo isDarkMode={props.isDarkMode} />
      <div className="topbar-left">
        <a
          className={`topbar-nav-item ${isOverview ? "is-active" : ""}`}
          href={`/overview`}
        >
          Overview
        </a>
        <a
          className={`topbar-nav-item ${isDocumenation ? "is-active" : ""}`}
          href={`/getting-started/introduction`}
        >
          Documentation
        </a>
        <a
          className={`topbar-nav-item ${isCommunity ? "is-active" : ""}`}
          href={`http://community.ikigailabs.io/`}
          target={"_blank"}
          rel="noreferrer"
        >
          Community
        </a>
      </div>
      <div className="topbar-right">
        <div className="topbar-search-holder">
          <Search
            pages={props.pages}
            selectSearch={(name: string, content: any) =>
              //this.getPageContent(name, content)
              {}
            }
          />
        </div>
        {/* <a
          href="https://app.ikigailabs.io"
          className="go-to-app"
          rel={"noreferrer"}
          target={"_blank"}
        >
          <span className="go-to-app-txt">Go to App</span>
          <span className="go-to-app-icon">&#8594;</span>
        </a> */}
        <a
          href="https://app.ikigailabs.io/login"
          className="app-btn log-in"
          rel={"noreferrer"}
          target={"_blank"}
        >
          <span className="go-to-app-txt">Log in</span>
        </a>
        <a
          href="https://app.ikigailabs.io/signup"
          className="app-btn sign-up"
          rel={"noreferrer"}
          target={"_blank"}
        >
          <span className="go-to-app-txt">Sign up</span>
        </a>
      </div>
      <div
        className={`hamburger-icon ${
          props.mobileMainMenuOpen ? "is-open" : ""
        }`}
        onClick={() => props.handleMobileMainMenuClick()}
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
}
